<template>
  <div class="model">
    <!-- 修改模板对话框 -->
    <el-dialog
      class="card"
      :visible.sync="dialogVisibleEdit"
      title="修改运费模板"
      width="80%"
      :before-close="handleClose"
    >
      <div class="title">运费设置</div>
      <!-- 模板名称和类型设置 -->
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="模板名称:" prop="templeName">
          <el-input v-model="form.templeName" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="计费方式:" prop="chargeType">
          <el-radio v-model="form.chargeType" :label="1" class="name-input name-input-radio">按件数</el-radio>
        </el-form-item>
      </el-form>

      <!-- 配送区域列表表头 -->
      <div class="freight flex">
        <div class="freight-region">
          <span>配送区:</span>
          可配送区域
        </div>
        <div>首件 (个)</div>
        <div>运费（元）</div>
        <div>续件（个）</div>
        <div>续费（元）</div>
      </div>

      <!-- 区域列表项 -->
      <div class="list flex" v-for="(item, index) in regions" :key="index">
        <!-- 配送的省份code -->
        <div class="region">
          <el-popover placement="left" width="200" trigger="hover">
            <div class="region-popover" style="padding: 0 0 20px 0">
              <span
                v-for="(row, indexRow) in item.citysName"
                :key="indexRow"
              >{{row.name}}{{item.citysName.length-1==indexRow?'':'、'}}</span>
            </div>
            <div class="region-slot" slot="reference">
              <span
                v-for="(row, indexRow) in item.citysName"
                :key="indexRow"
              >{{row.name}}{{item.citysName.length-1==indexRow?'':'、'}}</span>
            </div>
          </el-popover>
        </div>
        <!-- 操作按钮 -->
        <div class="region-item flex">
          <el-button type="text" @click="modify(index)">修改</el-button>
          <el-button type="text" style="color:red;" @click="handleDelete(index)">删除</el-button>
        </div>
        <!-- 首件 -->
        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.firstValue"
            @input="inputNumber($event,index,'firstValue')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
        <!-- 运费 -->
        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.firstFee"
            @input="limitInput($event,index,'firstFee')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
        <!-- 续件 -->
        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.continueValue"
            @input="inputNumber($event,index,'continueValue')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
        <!-- 续费 -->
        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.continueFee"
            @input="limitInput($event,index,'continueFee')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
      </div>

      <!-- 省份选择对话框 -->
      <el-dialog width="80%" title="配送区域" :visible="dialogVisible" append-to-body   :before-close="()=>{dialogVisible = false}">
        <div v-for="(item,index) in cities" :key="index" style="margin-bottom:15px;">
          <div class="flex">
            <el-checkbox
              v-model="selectedAllCities[index]"
              @change="selectAll($event,index)"
              style="margin-right:25px;"
            >{{item.regionName}}</el-checkbox>
            <el-checkbox-group
              v-model="checkedCities[index]"
              @change="handleCheckedCitiesChange($event,index)"
            >
              <el-checkbox v-for="city in item.data" :label="city.id" :key="city.id">{{city.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmRegion">确 定</el-button>
        </span>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button class="footer-add-modal-button" @click="addModel">指定可配送区域和运费</el-button>
        <el-button @click="$emit('closed')">取 消</el-button>
        <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// import { FreightAdd } from "@/types/api/freight";
import { updateByTemplateCode } from "@/api/freight";
import print from "@/utils/print";
import copy from "@/utils/deepCopy";
import inputPrice from "@/utils/inputPrice";

import FreightMix from "./mixin/freight";
export default {
  mixins: [FreightMix],
  // 父组件传来的值
  props: {
    form: {
      type: Object,
    },
    dialogVisibleEdit: {
      type: Boolean,
    },
    provinces: {
      type: Array,
    },
  },
  // 父组件传值监听
  watch: {
    form(val) {
      this.regions = [];
      for (let i = 0; i < val.data.length; i++) {
        let data = val.data[i];
        let arr = data.region.split(",");
        let popoverRegion = [];
        let citysName = [];
        this.provinces.map((e) => {
          arr.forEach((a) => {
            if (a == e.id) {
              popoverRegion.push(e.id);
              citysName.push(e);
            }
          });
        });
        // 切分配送区域
        this.regions.push({
          citysName: citysName,
          citys: popoverRegion,
          firstValue: data.firstValue,
          firstFee: data.firstFee,
          continueValue: data.continueValue,
          continueFee: data.continueFee,
        });
      }

      this.setCities(this.provinces);
    },
  },
  // 当前组件数据
  data() {
    return {
      // 提交请求的数组
      regions: [],
    };
  },
  methods: {
    // 确认提交
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = [];
          let reg = /\S/;
          for (let index = 0; index < this.regions.length; index++) {
            // 检查填写的内容不能为空
            if (
              reg.test(this.regions[index].continueFee) &&
              reg.test(this.regions[index].continueValue) &&
              reg.test(this.regions[index].firstFee) &&
              reg.test(this.regions[index].firstValue) &&
              reg.test(this.regions[index].citys.toString())
            ) {
              arr.push({
                chargeType: this.form.chargeType,
                continueFee: this.regions[index].continueFee,
                continueValue: this.regions[index].continueValue,
                firstFee: this.regions[index].firstFee,
                firstValue: this.regions[index].firstValue,
                region: this.regions[index].citys.toString(),
                templeName: this.form.templeName,
                id: this.form.id,
                templateCode: this.form.templateCode,
              });
            } else {
              return this.$message.error("填写内容不能为空");
            }
          }
          // 提交请求
          updateByTemplateCode(this.form.templateCode, arr).then((res) => {
            this.$message.success("保存成功");
            this.$emit("update");
            Object.keys(this.selectedAllCities).map((e) => {
              this.selectedAllCities[e] = false;
            });
            this.handleClose();
          });
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    handleClose() {
      this.$emit("closed");
    },

    // 取消(重置)
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.items = [];
    },

    // 限制只能输入数字，而且只能保留两位小数
    limitInput(val, index, key) {
      this.regions[index][key] = inputPrice(val);
    },
    // 限制只能输入数字
    inputNumber(val, index, key) {
      this.regions[index][key] = inputPrice(val, "number");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="../style.scss">
</style>
